import client from "./client";

/**
 * Signed Urls are only valid for 5mins so this request should
 * timeout after the same length of time as we know they will
 * fail after that anyway.
 */
const TIMEOUT = 300000;

export const uploadPhotoToSignedUrl = (signedUrl: string, photo: File) =>
  client.put(signedUrl, photo, {
    headers: { "Content-Type": "image/jpeg" },
    timeout: TIMEOUT,
  });
